import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sunrun/component-library';
import * as Yup from 'yup';
import styled from '@emotion/styled';
import mixpanel from '../../utilities/mixpanel';
import { ERROR_COLOR, GRAY_BORDER_COLOR_2 } from '../general/constants/_colors';
import { FAILED_FORM_SUBMISSION } from '../../constants/mixpanelEventNames';
import { Form, InputGroup } from '../general';

const Container = styled.div`
  textarea {
    height: 100px !important;
    margin-top: 10px;
    border-bottom: none;
    box-shadow: 0px 0px 0px 1px ${GRAY_BORDER_COLOR_2};
  }
`;

const Error = styled.p`
  color: ${ERROR_COLOR};
`;

const FeedbackFormComponent = ({ buttonText, label, onSubmit, submitError }) => {
  const [validationError, setValidationError] = useState(null);
  const initialValues = {
    feedback: '',
  };

  const validationSchema = Yup.object().shape({
    feedback: Yup.string().min(5, 'Please enter at least 5 characters').required('Please provide some feedback'),
  });

  const handleValidationFailure = formik => {
    if (formik && formik.errors && formik.errors.feedback) {
      mixpanel.track(FAILED_FORM_SUBMISSION, {
        'CTA Text': 'Share',
        Location: 'Support',
        'Data Type': 'Text Only',
        Error: formik.errors.feedback,
        'Text Input': formik.values.feedback,
      });
      setValidationError(formik.errors.feedback);
    }
  };

  return (
    <Container>
      <Form
        initialValues={initialValues}
        onSubmit={({ feedback }) => {
          onSubmit(feedback);
        }}
        validationSchema={validationSchema}
        validateOnBlur
        autoComplete="new-password"
        onValidationFail={handleValidationFailure}
      >
        <>
          {submitError && <Error>{submitError}</Error>}
          <InputGroup label={label} name="feedback" aria-label="feedback-textarea" maxLength={32000} hasError={validationError} textarea required />
          {validationError && <Error>{validationError}</Error>}
          <Button primary type="submit" data-testid="feedback-submit">
            {buttonText}
          </Button>
        </>
      </Form>
    </Container>
  );
};

FeedbackFormComponent.propTypes = {
  buttonText: PropTypes.string,
  label: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.string,
};

FeedbackFormComponent.defaultProps = {
  buttonText: 'Share',
  label: 'Feedback',
  submitError: null,
};

export default FeedbackFormComponent;
